export default "__VITE_ASSET__CCLNgBU5__"